// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".teleradiology-panel .fluid.ui.green.button{margin-bottom:0}", "",{"version":3,"sources":["webpack://./app/containers/Teleradiology/Panel/styles.scss"],"names":[],"mappings":"AACI,4CACI,eAAA","sourcesContent":[".teleradiology-panel {\r\n    .fluid.ui.green.button {\r\n        margin-bottom: 0;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
